export default "__VITE_ASSET__BKJifeHT__"